module.exports = __webpack_public_path__ + "static/media/isle-of-man.11130526.png";